export default "__VITE_ASSET__Db8LK9S3__"